export default {"src":"/_next/static/media/usdb.33190604.svg","height":140,"width":140,"blurWidth":0,"blurHeight":0};